	/*****
 * Initialize Lightbox Gallery
 *****/
  function initLightbox(parentClass) {
    if(typeof parentClass === 'undefined' || !parentClass) return; //early return if parentClass is undefined
  
    jQuery(parentClass+'__image_bg, '+parentClass+'__more').on('click', function(){
      var index = jQuery(this).data('index');
      var lightbox = jQuery(this).parents(parentClass).find(parentClass+'__lightbox');
      
      lightbox.addClass('active');
      setTimeout(function() { //strangely needs timeout to works
        lightbox.find('.lightbox').slick('slickGoTo', index, true);
      }, 10);
  
      jQuery('html').css('overflow-y', 'hidden');
      jQuery('body').css('overflow-y', 'hidden');
    });
  
    jQuery(parentClass+'__lightbox--close').on('click', function(){
      jQuery(this).parent().removeClass('active');
  
      jQuery('html').css('overflow-y', 'auto');
      jQuery('body').css('overflow-y', 'auto');
    });
  
    //Main Slider
    jQuery(parentClass+'__lightbox .lightbox').slick({
      slidesToShow: 1,
      infinite: false,
      dots: false,
      lazyLoad: 'ondemand',
      arrows: false
    });
  
    //Navigation Slider
    jQuery(parentClass+'__lightbox .lightbox-navigation').slick({
      slidesToShow: 3,
      infinite: false,
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      arrows: true,
      swipeToSlide: true,
      prevArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-left.svg' class='slick-prev' />",
      nextArrow: "<img src='/wp-content/themes/DailyPress/assets/images/arrow-right.svg' class='slick-next' />",
      asNavFor: parentClass+'__lightbox .lightbox',
      responsive: [
        {
          breakpoint: 680,
          settings: {
              slidesToShow: 3,
          }
        }
      ]
    });
  }
  initLightbox('.gallery');